import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import ModeInputHelperText from './ModeInputHelperText.react';

const thousandsSeparator = (val) => {
  // Split on decimal point
  const split = String(val).split('.');

  // Grab number to the left of the decimal point
  const left = split[0].length > 0 ? String(Number(split[0])) : '';

  // Grab number to the right of the decimal point
  // (and add a decimal point to the string if it's there)
  const right = split.length > 1 ? `.${split[1]}` : '';

  // Cast the left side as string, split it into each digit, and
  // starting from the back (1's column), group digits by 3's and add a comma
  // then split it, reverse it, and put it back together again
  // and join it back to the right side of the decimal (if there is one)
  return String(left).split('').reverse().join('')
                .replace(/(\d{3}\B)/g, '$1,')
                .split('')
                .reverse()
                .join('') + right;
};

export default class CostInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const updateVal = e.target.value.replace(/[^.0-9]+/g, '');
    this.props.updateCost(updateVal);
    if (!this.props.mode.selected && this.props.mode.cost.length === 0 && updateVal.length > 0) {
      this.props.updateSelected(true);
    }
  }

  costForDisplay() {
    return `$ ${thousandsSeparator(this.props.mode.cost)}`;
  }

  render() {
    return (
      <FormGroup className='budget-constraint-group'>
        <FormControl
          type='text'
          value={this.costForDisplay()}
          onChange={this.onChange}
        />
        <ModeInputHelperText
          text={this.props.mode.costText}
          tooltip={this.props.mode.costTooltip}
        />
      </FormGroup>
    );
  }
}

CostInput.propTypes = {
  mode: PropTypes.object,
  updateCost: PropTypes.func,
  updateSelected: PropTypes.func,
};
